import { render, staticRenderFns } from "./SelectSongs.vue?vue&type=template&id=38c5c5ed&scoped=true&"
import script from "./SelectSongs.vue?vue&type=script&lang=ts&"
export * from "./SelectSongs.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSongs.vue?vue&type=style&index=0&id=38c5c5ed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5c5ed",
  null
  
)

export default component.exports